export const isDev: boolean = import.meta.env.VITE_APP_ENV === "dev"
export const isUat: boolean = import.meta.env.VITE_APP_ENV === "uat"
export const isProd: boolean = import.meta.env.VITE_APP_ENV === "prod"
export const serverUrl: string = import.meta.env.VITE_APP_SERVER_URL
export const appUrl: string = import.meta.env.VITE_APP_URL
export const smartyKey: string = import.meta.env.VITE_APP_SMARTY_KEY
export const freshpaintToken: string = import.meta.env.VITE_APP_FRESHPAINT_TOKEN

export const sentryUrl = "https://72a04703c05e4c889dea0d433607788c@o675910.ingest.sentry.io/4504475985379328"

export const COVERED_PHARMACIES_LIST = "https://providers.vitablehealth.com/assets/ventegra_nationwide_network.pdf"

export const LABCORP_LAB_LOCATOR_LINK = "https://www.labcorp.com/labs-and-appointments-advanced-search"
export const LABCORP_DRUG_AND_ALCOHOL_LAB_LOCATOR_LINK = "https://www.labcorpsolutions.com/ots/locator.do"
export const GETLABS_SCHEDULING_LINK = "https://app.getlabs.com/vitablehealth"
export const QUEST_LAB_LOCATOR_LINK = "https://appointment.questdiagnostics.com/find-location/as-location-finder"
export const CVS_MINUTE_CLINIC_LOCATOR_LINK = "https://www.cvs.com/minuteclinic/clinic-locator/"
export const PARTIALLY_COVERED_MEDS_FORMULARY_LINK =
  "https://providers.vitablehealth.com/assets/vitable_limited_coverage_prescriptions.pdf"

export const MIN_MEMBER_COVERAGE_AGE_IN_MONTHS = 18
export const MAX_MEMBER_COVERAGE_AGE_IN_YEARS = 64

export const SCHEDULING_EMAIL = "scheduling@vitablehealth.com"
export const SCHEDULING_PHONE = "4844160769"
export const ENROLLMENTS_EMAIL = "enrollments@vitablehealth.com"
export const ENROLLMENTS_PHONE = "4844699177"
